import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Spin, Typography, Breadcrumb as AntdBreadcrumb } from 'antd';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import {
  Breadcrumb as BreadcrumbType,
  BreadcrumbContext,
} from '@/contexts/BreadcrumbContextProvider';
import { useWindowSize } from '@/hooks';

const { Text } = Typography;

const PageTitle: React.FC = () => {
  const context = useContext(BreadcrumbContext);
  const { width } = useWindowSize();

  const renderBreadcrumbLabel = (bc: BreadcrumbType) => {
    if (bc.isParam) {
      if (bc.label === 'commons.form.loading') {
        return (
          <Text ellipsis>
            <Spin
              indicator={
                <Loading3QuartersOutlined spin style={{ color: '#ffffff' }} />
              }
              size="small"
            />
          </Text>
        );
      }
      return (
        <Text
          ellipsis={{ tooltip: bc.label }}
          style={{ maxWidth: 160, color: 'white' }}
        >
          {bc.label}
        </Text>
      );
    }
    return (
      <Text ellipsis style={{ color: 'white' }}>
        <FormattedMessage id={bc.label} />
      </Text>
    );
  };

  return (
    <h1 className="page-title">
      {width < 1092 ? (
        context?.breadcrumbs.at(-1) && (
          <FormattedMessage id={context?.breadcrumbs.at(-1)?.label || ''} />
        )
      ) : (
        <AntdBreadcrumb separator=">">
          {context?.breadcrumbs?.map((bc: BreadcrumbType) => (
            <AntdBreadcrumb.Item key={bc.key}>
              {renderBreadcrumbLabel(bc)}
            </AntdBreadcrumb.Item>
          ))}
        </AntdBreadcrumb>
      )}
    </h1>
  );
};

export default PageTitle;
